import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "SalesId",
      label: "平台销售订单编号",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "InvoiceAccount",
      label: "发票帐户",
      sortable: true
    },
    {
      key: "DeliveryDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "OrderAmount",
      label: "订单金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "OrderAmountWOTax",
      label: "本币不含税金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "ExchRate",
      label: "汇率",
      sortable: true,
      type: "number",
      _precise: 4
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "SalesPoolId",
      label: "池",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },

    {
      key: "TEC_Remark",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },

    {
      key: "SOApprover",
      label: "订单待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "fcCheckSOApproved",
      label: "订单审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSOApproved",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOApprovedState",
      label: "订单审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOApproved) {
          item.SOApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "SOCreditControlApprover",
      label: "信用待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "approved_comment",
      label: "信用控制意见",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "fcCheckSOCreditControlApproved",
      label: "信用控制状态",
      sortable: true,
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOCreditControlApprovedState",
      label: "信用审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOCreditControlApproved) {
          item.SOCreditControlApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOCreditControlApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOCreditControlApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "SOPriceDiffApprover",
      label: "价格待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "fcCheckSOPriceDffApproved",
      label: "价格审批",
      sortable: true,
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOPriceDffApprovedState",
      label: "价格审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOPriceDffApproved) {
          item.SOPriceDffApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOPriceDffApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOPriceDffApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,

      type: "number"
    },
    {
      key: "SalesPrice",
      label: "价格",
      sortable: true,

      type: "number",
      _precise: 6
    },
    {
      key: "DiscPrice",
      label: "协议价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "ItemCurrencyCode",
      label: "价格币种",
      sortable: true
    },
    {
      key: "SalesPriceWOTax",
      label: "本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_state",
      label: "价格状态",
      sortable: true,
      type: "icon"
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,

      type: "date"
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,

      type: "date"
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,

      type: "date"
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true,
      type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "TEC_OtherInfo",
      label: "其他信息",
      sortable: true,

      type: "textarea"
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true,

      type: "textarea"
    },

    {
      key: "RetailVariantId",
      label: "变型名称",
      sortable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      type: "number",
      _precise: 6
    }
  ]
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  async getData(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_salesorder_and_salesline",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}
export { biz_data, fields, methods, rules }

